import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import '../../../App.css'
import '../../../styles/scss/student_dashboard.css'
import '../../../styles/scss//tutor/tutor_dashboard.css'
import '../../../styles/scss/main/header.css'
import '../../../styles/scss/main/footer.css'
import '../../../styles/scss/main/breadcrum.css'
import '../../../styles/scss/main/sidebar.css'
import '../../../styles/scss/student_dashboard.css'
import '../../../styles/scss/tutor/tutor_dashboard.css'
import '../../../styles/scss/tutor/my_student.css'
import '../../../styles/scss/tutor/chat.css'
import '../../../styles/scss/student_queries.css'
import '../../../styles/scss/tutor_reviews.css'
import '../../../styles/scss/tutor_profile.css'
import '../../../styles/scss/tutor/study_material.css'
import '../../../styles/scss/tutor/add_study_material.css'
import '../../../styles/scss/tutor/course_list.css'
import '../../../styles/scss/tutor/add_new_course.css'
import '../../../styles/scss/tutor/my_schedule_details.css'
import '../../../styles/scss/tutor/my_earning.css'
import '../../../styles/scss/student/browse_tutor.css'
import '../../../styles/scss/student/input.css'

import StudentDashboard from './StudentDashboard'
import StudentHeader from '../StudentHeader/StudentHeader'
import StudentFooter from '../StudentFooter/StudentFooter'
import StudentBooking from '../StudentBooking/StudentBooking'
import StudentProfile from '../StudentProfile/StudentProfile'
import StudentProfileUpdate from '../StudentProfile/StudentProfileUpdate'
import StudentBrowseTutor from '../StudentBrowseTutor/StudentBrowseTutor'
import StudentTutorList from '../StudentBrowseTutor/StudentTutorList/StudentTutorList'
import StudentReqOneToOneTutoring from '../StudentBrowseTutor/StudentReqOneToOneTutoring/StudentReqOneToOneTutoring'
import StudentTutorGroupCourseList from '../StudentBrowseTutor/StudentTutorGroupCourseList/StudentTutorGroupCourseList'
import StudentGroupBatchSession from '../StudentBrowseTutor/StudentGroupBatchSession/StudentGroupBatchSession'
import StudentSessionPayment from '../StudentBrowseTutor/StudentSessionPayment/StudentSessionPayment'
import StudentRequestForTutor from '../StudentRequestForTutor/StudentRequestForTutor'
import StudentCourseDetails from '../StudentRequestForTutor/StudentCourseDetails/StudentCourseDetails'
import StudentMySessions from '../StudentMySessions/StudentMySessions'
import StudentOneToOneCourseDetails from '../StudentMySessions/StudentOneToOneCourseDetails/StudentOneToOneCourseDetails'
import StudentGroupCourseDetails from '../StudentMySessions/StudentGroupCourseDetails/StudentGroupCourseDetails'
import StudentOnlineLecture from '../StudentOnlineLecture/StudentOnlineLecture'
import StudentNotesHandouts from '../StudentNotesHandouts/StudentNotesHandouts'
import StudentVideoNotes from '../StudentNotesHandouts/StudentVideoNotes/StudentVideoNotes'
import StudentImageNotes from '../StudentNotesHandouts/StudentImageNotes/StudentImageNotes'
import StudentPdfNotes from '../StudentNotesHandouts/StudentPdfNotes/StudentPdfNotes'
import StudentPptNotes from '../StudentNotesHandouts/StudentPptNotes/StudentPptNotes';
import StudentDocNotes from '../StudentNotesHandouts/StudentDocNotes/StudentDocNotes';
import StudentNotesQueries from '../StudentNotesHandouts/StudentNotesQueries/StudentNotesQueries'
import StudentMyAssignments from '../StudentMyAssignments/StudentMyAssignments'
import StudentNotification from '../StudentNotification/StudentNotification'
import StudentContactUs from '../StudentContactUs/StudentContactUs'
import StudentReview from '../StudentReview/StudentReview'
import StudentMessage from '../StudentMessage/StudentMessage'
import StudentTutorGroupBatchList from '../StudentBrowseTutor/StudentTutorGroupBatchList/StudentTutorGroupBatchList'
import StudentChat from '../StudentMessage/StudentChat'
import MeetingFrame from '../../VideoMeet/MeetingFrame'
import FeedbackForm from '../../FeedbackForm/FeedbackForm'
import StudentRecordedVideos from '../StudentRecordedVideos/StudentRecordedVideos'



const StudentHome = () => {
    return (
        <div>

            <StudentHeader />
            <Routes>
                <Route index element={<Navigate to="dashboard" />} />
                <Route path="*" element={<Navigate to="dashboard" />} />
                <Route path='dashboard' element={<StudentDashboard />} />
                <Route path='bookings' element={<StudentBooking />} />
                <Route path='profile' element={<StudentProfile />} />
                <Route path='profile-update' element={<StudentProfileUpdate />} />
                <Route path='browse-tutor' element={<StudentBrowseTutor />} />
                <Route path='tutor-list' element={<StudentTutorList />} />
                <Route path='request-for-one-to-one/:b64id' element={<StudentReqOneToOneTutoring />} />
                <Route path='view-group-courses/:b64id' element={<StudentTutorGroupCourseList />} />
                <Route path='view-group-course-batches/:b64id' element={<StudentTutorGroupBatchList />} />
                <Route path='group-batch-session/:b64id' element={<StudentGroupBatchSession />} />
                <Route path='session-payment' element={<StudentSessionPayment />} />
                <Route path='request-for-tutor' element={<StudentRequestForTutor />} />
                <Route path='course-details/:b64id' element={<StudentCourseDetails />} />
                <Route path='my-sessions' element={<StudentMySessions />} />
                <Route path='message' element={<StudentMessage />} />
                <Route path='chat/:b64id' element={<StudentChat />} />
                <Route path='one-to-one-course-details/:b64id' element={<StudentOneToOneCourseDetails />} />
                <Route path='group-course-details/:b64id' element={<StudentGroupCourseDetails />} />
                <Route path='my-online-lecture' element={<StudentOnlineLecture />} />
                <Route path='notes-and-handouts' element={<StudentNotesHandouts />} />
                <Route path='video-notes' element={<StudentVideoNotes />} />
                <Route path='image-notes' element={<StudentImageNotes />} />
                <Route path='pdf-notes' element={<StudentPdfNotes />} />
                <Route path='ppt-notes' element={<StudentPptNotes />} />
                <Route path='doc-notes' element={<StudentDocNotes />} />
                <Route path='my-queries' element={<StudentNotesQueries />} />
                <Route path='my-assignments' element={<StudentMyAssignments />} />
                <Route path='notification' element={<StudentNotification />} />
                <Route path='contact-us' element={<StudentContactUs />} />
                <Route path='reviews' element={<StudentReview />} />
                <Route path='recordings/:b64id' element={<StudentRecordedVideos />} />


            </Routes>
            <FeedbackForm />
            <StudentFooter />
        </div>
    )
}

export default StudentHome